import React from 'react';
import { ContentRelatedTo } from '@nexspec/warehouse-shared-types/src/titles/TitleMetadata/ContentRelatedTo';
import { TitleFull } from '@warehouse/title/core';
import useTitleAutoSave from '../../../src/views/title/hooks/useTitleAutoSave/useTitleAutoSave';
import useMemoJsonPath from '../../../src/views/title/hooks/useMemoJsonPath';
import { LoaderWrapper } from '../../../src/components/library/LoaderWrapper';
import { adapt, updatePrimaryInWorkItem, updateWorkItemsDelete } from './content-relatedto-relationship.adapter';
import { ContentRelatedToRelationshipEditor } from './ContentRelatedToRelationshipEditor';

export function ContentRelatedToRelationshipEditorAdapter({
	childUuid,
	childData,
	parentData,
	onClose,
}: ContentRelatedToRelationshipEditorAdapterProps) {
	const {
		value: contentRelatedTo,
		setValue: setContentRelatedTo,
		commit,
	} = useTitleAutoSave<ContentRelatedTo[]>({
		path: useMemoJsonPath(['metadata', 'coreMetadata', 'basic', 'contentRelatedTo']),
		label: 'Content related to',
		isInheritable: false,
	});

	// UseTitleAutoSave can return undefined on the first render
	if (!contentRelatedTo || contentRelatedTo.length === 0) {
		return (
			<div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				<LoaderWrapper loading opacity={100} />
			</div>
		);
	}

	const { childTitle, parentTitle, primary } = adapt({
		childUuid,
		contentRelatedTo,
		childData,
		parentData,
	});

	const updatePrimary = (newPrimary: boolean) => {
		const updatedContentRelatedTo = updatePrimaryInWorkItem(newPrimary, childUuid, contentRelatedTo);
		setContentRelatedTo(updatedContentRelatedTo);
	};

	const deleteChild = () => {
		setContentRelatedTo(updateWorkItemsDelete(childUuid, contentRelatedTo));
		commit();
		onClose(true);
	};

	return (
		<ContentRelatedToRelationshipEditor
			childTitle={childTitle}
			parentTitle={parentTitle}
			primary={primary}
			updatePrimary={updatePrimary}
			deleteChild={deleteChild}
			commitChanges={commit}
		/>
	);
}

interface ContentRelatedToRelationshipEditorAdapterProps {
	childUuid: string;
	childData: TitleFull;
	parentData: TitleFull;
	onClose: (force?: boolean) => void;
}
